module.exports = __webpack_public_path__ + "img/cb-action-delete.232d473f.svg";